<q9-content-loader [isLoading]="loading"></q9-content-loader>

<div class="modal" *ngIf="!loading">
  <div mat-dialog-title>
    <span>{{ translations?.title | translate }}</span>

    <q9-dialog-close-button></q9-dialog-close-button>
  </div>

  <mat-dialog-content>
    <p>{{ translations?.text }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <q9-secondary-button mat-dialog-close color="warn">
      {{'POPUPS.CANCEL' | translate}}
    </q9-secondary-button>

    <q9-primary-button color="warn" (click)="deleteNode()">
      {{'POPUPS.CONFIRM_DEL_SUBMIT' | translate}}
    </q9-primary-button>
  </mat-dialog-actions>
</div>
